import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress
} from '@mui/material';

const DeleteDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  productId, 
  isSubmitting 
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        Potwierdź usunięcie
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          Czy na pewno chcesz usunąć ten produkt? Tej operacji nie można cofnąć.
          <br />
          ID produktu: {productId}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          color="primary"
          disabled={isSubmitting}
        >
          Anuluj
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          disabled={isSubmitting}
          startIcon={isSubmitting && <CircularProgress size={20} />}
        >
          {isSubmitting ? 'Usuwanie...' : 'Usuń'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
